export class AccountConfigInput {
    'cloudProvider';
    'aws';
    'azure';
    'gcp';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsAccountConfigInput",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "AzureAccountConfigInput",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpAccountConfigInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccountConfigInput.attributeTypeMap;
    }
    constructor() {
    }
}
